import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation updateWorkflowNoHistory($projectId: String!, $input: UpdateWorkflowNoHistoryInput!) {
    updateWorkflowNoHistory(projectId: $projectId, input: $input) {
      ...WorkflowFields
      thumbnail
    }
  }
`
